import { MoreHoriz, Reply } from "@mui/icons-material";
import { Box } from "@mui/material";
import commentimg from "../assets/img/comment.svg";

export default function CustomCommentIcon({ className, style, onClick }) {
    const scale = 1.0;
    return <Box
        sx={{
            position: "relative",
            width: 24 * scale,
            height: 20 * scale,
            backgroundColor: "transparent",
        }}

        className={className}
        style={style}
        onClick={onClick}
    >
        <img src={commentimg} className="scale-x-[-1] absolute top-[2px] right-[0px] z-0" />
        <img src={commentimg} className="absolute top-[0px] right-[3px] bg-white z-1" />
        <MoreHoriz className="absolute top-[2px] right-[5px] text-sm z-2" />
    </Box>;
};